import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { FullSpinner } from "@/components/States";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

const BLANK = { type: "article", category: "General", title: "", body: "", status: "draft", order: 50, severity: "info", start_at: "", end_at: "" };

export default function AdminSafety() {
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);

  const load = () => api.get("/admin/safety-content").then(({ data }) => setItems(data.content));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) await api.put(`/admin/safety-content/${edit.id}`, edit);
      else await api.post("/admin/safety-content", edit);
      toast.success("Saved"); setEdit(null); load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const archive = async (id) => { if (!window.confirm("Archive this content?")) return; await api.delete(`/admin/safety-content/${id}`); load(); };

  if (!items) return <FullSpinner label="Loading safety content…" />;
  const SB = { published: "bg-emerald-900/40 text-emerald-300", draft: "bg-amber-900/40 text-amber-300", archived: "bg-slate-700 text-slate-300" };
  return (
    <div className="space-y-5" data-testid="admin-safety">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl font-bold">Safety Education</h1>
        <button onClick={() => setEdit({ ...BLANK })} data-testid="safety-add" className="btn-gold px-4 py-2 rounded-xl flex items-center gap-2 text-sm"><Plus className="w-4 h-4" /> New content</button>
      </div>

      {edit && (
        <div className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl p-4 space-y-2" data-testid="safety-editor">
          <div className="grid sm:grid-cols-3 gap-2">
            <select value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })} className="bg-[#1A090D] border border-[#781826]/40 rounded-lg px-2 py-2 text-sm text-white" data-testid="safety-type">
              <option value="article">Article</option><option value="faq">FAQ</option><option value="notice">Notice</option>
            </select>
            <input value={edit.category} onChange={(e) => setEdit({ ...edit, category: e.target.value })} placeholder="Category" className="bg-[#1A090D] border border-[#781826]/40 rounded-lg px-2 py-2 text-sm text-white" />
            <select value={edit.status} onChange={(e) => setEdit({ ...edit, status: e.target.value })} className="bg-[#1A090D] border border-[#781826]/40 rounded-lg px-2 py-2 text-sm text-white" data-testid="safety-status">
              <option value="draft">Draft</option><option value="published">Published</option><option value="archived">Archived</option>
            </select>
          </div>
          <input value={edit.title} onChange={(e) => setEdit({ ...edit, title: e.target.value })} placeholder="Title / question" data-testid="safety-title" className="w-full bg-[#1A090D] border border-[#781826]/40 rounded-lg px-3 py-2 text-sm text-white" />
          <textarea value={edit.body} onChange={(e) => setEdit({ ...edit, body: e.target.value })} placeholder="Body / answer" rows={4} data-testid="safety-body" className="w-full bg-[#1A090D] border border-[#781826]/40 rounded-lg px-3 py-2 text-sm text-white" />
          <div className="flex gap-2 justify-end">
            <button onClick={() => setEdit(null)} className="text-sm px-4 py-2 rounded-lg bg-[#1A090D] text-[#D8B4B9]">Cancel</button>
            <button onClick={save} data-testid="safety-save" className="btn-gold text-sm px-4 py-2 rounded-lg">Save</button>
          </div>
        </div>
      )}

      <div className="bg-[#2A0F14] border border-[#781826]/40 rounded-2xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-[#C59B27] uppercase border-b border-[#781826]/40"><th className="p-3">Title</th><th>Type</th><th>Category</th><th>Status</th><th>v</th><th></th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="border-b border-[#781826]/20" data-testid={`safety-row-${c.id}`}>
                <td className="p-3">{c.title}</td><td className="text-xs uppercase">{c.type}</td><td className="text-xs">{c.category}</td>
                <td><span className={`text-xs px-2 py-0.5 rounded-full ${SB[c.status]}`}>{c.status}</span></td>
                <td className="text-xs">{c.version}</td>
                <td className="flex gap-2 p-3">
                  <button onClick={() => setEdit({ ...BLANK, ...c })} data-testid={`safety-edit-${c.id}`} className="text-xs text-[#C59B27]">Edit</button>
                  <button onClick={() => archive(c.id)} className="text-rose-300"><Trash2 className="w-4 h-4" /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
